import { useLandingLoginRedirect } from '../hooks/useLandingLoginRedirect';

export function LandingLoginRedirect() {
	useLandingLoginRedirect();
	return null;
}
